import { useSettingsHeader } from "@circle-react-shared/uikit/HeaderV3/useSettingsHeader";
import { ABOUT_CIRCLE_V4_PATH } from "@circle-react/components/NewVersionOptIn/constants";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  isPromoCodeEnabled,
  isSubscriptionExpired,
} from "@circle-react/helpers/communityHelpers";
import { useIsAppShellAdminAreaEnabled } from "@circle-react/hooks/useIsAppShellAdminAreaEnabled";
import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";
import { useTailwindLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useMatchRoute } from "@tanstack/react-router";

import { useRouteHelpers } from "@/react/routes/Main/useRouteHelpers";

// Exact copy of the HeaderV3 visibility checks
export const useHeaderV4Visibility = () => {
  const { currentCommunity } = usePunditUserContext();
  const isLgScreen = useTailwindLgScreenMediaQuery();
  const isIframeEmbed = useIsIframeEmbed();
  const { isDiscoverPage, isLivePage } = useRouteHelpers();
  const matchRoute = useMatchRoute();
  const isEoyRecapRoute = matchRoute({ to: "/settings/recap-2025" });
  const isCircleV4LandingPage = matchRoute({ to: ABOUT_CIRCLE_V4_PATH });
  const {
    isSettingsRoute,
    isReactFlowWorkflowsRoute,
    isBotBuilderEditorRoute,
  } = useSettingsHeader();
  const hasSubscriptionExpired = isSubscriptionExpired(currentCommunity);
  const isPromoCodeEnabledForCommunity = isPromoCodeEnabled(currentCommunity);
  const isAppShellAdminAreaEnabled = useIsAppShellAdminAreaEnabled();

  const isHidden =
    !isLgScreen ||
    isIframeEmbed ||
    isEoyRecapRoute ||
    isCircleV4LandingPage ||
    isReactFlowWorkflowsRoute ||
    isBotBuilderEditorRoute ||
    hasSubscriptionExpired ||
    isPromoCodeEnabledForCommunity ||
    isLivePage ||
    isDiscoverPage ||
    (isAppShellAdminAreaEnabled && isSettingsRoute);

  return { isHidden };
};
